export default {
  SET_RESULT_UPLOAD(state, payload) {
    state.audienceSummary = payload
  },

  EDIT_COLUMN(state, payload) {
    const position = state.audienceSummary.data.items.findIndex((item) => item.fileColumnPosition == payload.position)
    state.audienceSummary.data.items[position].edit = !state.audienceSummary.data.items[position].edit

    if (state.audienceSummary.data.items[position].state.value === 'IGNORED') {
      state.audienceSummary.data.items[position].state = { key: 1, value: 'UNMAPPED' }
    }
  },

  UPDATE_MAIN_COLUMN(state, payload) {
    if (payload.event == 'click') {
      state.audienceSummary.data.items.forEach((item) => {
        if (payload.position === item.fileColumnPosition) {
          item.isKey = !item.isKey
        }
      })
      return
    }

    state.audienceSummary.data.items.forEach((item) => {
      if (payload.items.includes(item.fileColumnPosition)) {
        item.isKey = true
        return
      }

      item.isKey = false
    })
  },

  REMOVE_MAIN_COLUMN(state, payload) {
    state.audienceSummary.data.items.forEach((item) => {
      if (payload.position === item.fileColumnPosition) {
        item.isKey = false
      }
    })
  },

  ADD_COLUMN(state, payload) {
    if (payload) {
      state.audienceSummary.data.items.push(payload)
      return
    }
    state.audienceSummary.data.items = JSON.parse(JSON.stringify(state.audienceSummary.data.items))
  },

  ACTION_PROPERTY(state, payload) {
    const position = state.audienceSummary.data.items.findIndex((item) => item.fileColumnPosition == payload.position)
    state.audienceSummary.data.items[position].state = payload.state
    state.audienceSummary.data.items[position].edit = false

    if (payload.state.key === 3) {
      state.audienceSummary.data.items[position].isKey = false
    }
  },

  ADD_SELECT_TYPES(state, payload) {
    state.selectTypes = payload
  },

  ADD_DEFAULT_SELECT_TYPES(state, payload) {
    state.selectTypes.push(payload)
  },

  UPDATE_SELECT_TYPES(state, payload) {
    const index = state.selectTypes.length - 2
    state.selectTypes[index].types.push({
      ...payload.type,
      key: state.selectTypes[index].types.length + 1,
    })
  },

  UPDATE_TYPE(state, payload) {
    const position = state.audienceSummary.data.items.findIndex((item) => item.fileColumnPosition == payload.position)
    state.audienceSummary.data.items[position].type = payload.type
    state.audienceSummary.data.items[position].format = payload.format

    if (state.audienceSummary.data.items[position].new) {
      state.audienceSummary.data.items[position].fileColumnName = payload.type.value
    }
  },

  CLEAR_SUMMARY(state) {
    state.audienceSummary = {}
  },

  UPDATE_NAME_COLUMN(state, payload) {
    state.audienceSummary.data.items[payload.position].fileColumnName = payload.newName
  },

  UPDATE_HAS_AUDIENCE(state, payload) {
    state.hasAudience = payload
  },

  UPDATE_STATUS_AUDIENCE(state, status) {
    state.statusAudience = status
  },

  UPDATE_TAGS(state, tags) {
    state.audienceSummary.data.tags = tags
  },

  // DETAIL
  UPDATE_SCHEMA_AUDIENCE(state, payload) {
    state.schemaAudience = payload
  },

  UPDATE_RECIPIENT(state, payload) {
    state.recipient = { ...payload.data }
  },

  UPDATE_AUDIENCE_FEED(state, payload) {
    state.audienceFeed = payload
  },

  // New Audience
  SET_IMPORT_CONTACTS_STEP(state, payload) {
    state.importContacts.currentStep = payload
  },

  SET_IMPORT_CONTACTS_VALID_STEPS(state, payload) {
    state.importContacts.validSteps = payload
  },

  SET_IMPORT_CONTACTS_COMPLETED_STEPS(state, payload) {
    state.importContacts.completedSteps = payload
  },

  CLEAR_IMPORT_CONTACTS_STATE(state) {
    state.importContacts = {
      currentStep: 1,
      validSteps: [],
      completedSteps: [],
      importedData: undefined,
      importSuccess: false,
    }
  },

  SET_IMPORTED_DATA(state, payload) {
    state.importContacts.importedData = payload
  },

  UPDATE_IMPORTED_DATA_ITEM(state, payload) {
    const position = state.importContacts.importedData.items.findIndex((item) => item.fileColumnPosition == payload.position)

    state.importContacts.importedData.items[position].type = payload.type || null
    state.importContacts.importedData.items[position].format = payload.format || null
    state.importContacts.importedData.items[position].state = payload.state

    if (state.importContacts.importedData.items[position].new) {
      state.importContacts.importedData.items[position].fileColumnName = payload.type.value
    }

    if (payload.state.key === 3) {
      state.importContacts.importedData.items[position].isKey = false
    }
  },

  SET_COLUMN_AS_KEY(state, payload) {
    const position = state.importContacts.importedData.items.findIndex((item) => item.fileColumnPosition == payload.position)

    state.importContacts.importedData.items[position].isKey = payload.isKey
  },

  ADD_IMPORTED_DATA_TAGS(state, tags) {
    state.importContacts.importedData.tags = tags
  },

  SET_IMPORT_SUCCESS(state, value) {
    state.importContacts.importSuccess = value
  },
}
